import { React } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import './assets/css/Routes.css'

//Componentes Vistas
import Layout from './components/vistas/auth/Layout'
import Public from './components/vistas/auth/Public'
import RequireAuth from './components/vistas/auth/RequireAuth'
import Login from './components/vistas/auth/Login'

import Navbar from './components/vistas/Navbar'

import Home from './components/vistas/Home'

import Cronograma from './components/vistas/cronograma/Cronograma'
import CronogramaCrear from './components/vistas/cronograma/CronogramaCrear'
import CronogramaEditar from './components/vistas/cronograma/CronogramaEditar'
import CronogramaEliminar from './components/vistas/cronograma/CronogramaEliminar'

import Descuentos from './components/vistas/descuentos/Descuentos'
import DescuentosCrear from './components/vistas/descuentos/DescuentosCrear'
import DescuentosEditar from './components/vistas/descuentos/DescuentosEditar'
import DescuentoEliminar from './components/vistas/descuentos/DescuentoEliminar'

import Productos from './components/vistas/productos/Productos'
import ProductosCrear from './components/vistas/productos/ProductosCrear'
import ProductosEditar from './components/vistas/productos/ProductosEditar'
import ProductosEliminar from './components/vistas/productos/ProductosEliminar'

import Abonados from './components/vistas/abonados/Abonados'
import Abonado from './components/vistas/abonados/Abonado'
import AbonadoEliminar from './components/vistas/abonados/AbonadoEliminar'
import AbonadoCancelarSuscripcion from './components/vistas/abonados/AbonadoCancelarSuscripcion'


import Workshops from './components/vistas/workshops/Workshops'
import WorkshopsCrear from './components/vistas/workshops/WorkshopsCrear'
import WorkshopsEditar from './components/vistas/workshops/WorkshopsEditar'
import WorkshopsEliminar from './components/vistas/workshops/WorkshopsEliminar'


import FormularioSuscripcionPage from './components/vistas/formularios/formulario-suscripcion/FormularioSuscripcionPage'
import FormularioSuscripcionCrear from './components/vistas/formularios/formulario-suscripcion/FormularioSuscripcionCrear'
import FormularioSuscripcionEditar from './components/vistas/formularios/formulario-suscripcion/FormularioSuscripcionEditar'
import FormularioSuscripcionEliminar from './components/vistas/formularios/formulario-suscripcion/FormularioSuscripcionEliminar'

export default function Router() {



  return (
    <BrowserRouter>
      <Navbar />

      <Routes >

        <Route path="/" element={<Layout />} />
        <Route index element={<Public />} />
        <Route path="login" element={<Login />} />

        <Route element={<RequireAuth />}>

        <Route path="home" element={<Home />} />

        <Route path="cronograma" element={<Cronograma />} />
        <Route path="cronograma/crear" element={<CronogramaCrear />} />
        <Route path="cronograma/editar/:idCronograma" element={<CronogramaEditar />} />
        <Route path="cronograma/eliminar/:idCronograma" element={<CronogramaEliminar />} />

        <Route path="descuentos" element={<Descuentos />} />
        <Route path="descuentos/crear" element={<DescuentosCrear />} />
        <Route path="descuentos/editar/:idDescuento" element={<DescuentosEditar />} />
        <Route path="descuentos/eliminar/:idDescuento" element={<DescuentoEliminar />} />

        <Route path="productos" element={<Productos />} />
        <Route path="productos/crear" element={<ProductosCrear />} />
        <Route path="productos/editar/:idProducto" element={<ProductosEditar />} />
        <Route path="productos/eliminar/:idProducto" element={<ProductosEliminar />} />

        <Route path="abonados/:filtro" element={<Abonados />} />
        <Route path="abonados/ficha/:id" element={<Abonado />} />
        <Route path="abonados/eliminar/:id" element={<AbonadoEliminar />} />
        <Route path="abonados/cancelar-suscripcion/:id" element={<AbonadoCancelarSuscripcion />} />

        
        <Route path="workshops" element={<Workshops />} />
        <Route path="workshops/crear" element={<WorkshopsCrear />} />
        <Route path="workshops/editar/:idWorkshop" element={<WorkshopsEditar />} />
        <Route path="workshops/eliminar/:idWorkshop" element={<WorkshopsEliminar />} />

        <Route path="formularios/formulario-suscripcion/crear" element={<FormularioSuscripcionCrear />} />
        <Route path="formularios/formulario-suscripcion/:estadoFiltro?" element={<FormularioSuscripcionPage />} />
        <Route path="formularios/formulario-suscripcion/editar/:id" element={<FormularioSuscripcionEditar />} />
        <Route path="formularios/formulario-suscripcion/eliminar/:id" element={<FormularioSuscripcionEliminar />} />

        

        </Route>

      </Routes>



    </BrowserRouter >
  );

}